import {configureStore, getDefaultMiddleware} from '@reduxjs/toolkit'

// Redux Store Configuration
// Optimized for performance with large datasets (exercices, exams, etc.)
import AuthReducer from './reducers/auth/slice'
import LicenseReducer from './reducers/licenses/slice'
import UsersReducer from './reducers/users/slice'
import EstablishmentsReducer from './reducers/establishements/slice'
import ClassesReducer from './reducers/classes/slice'
import SubjectsReducer from './reducers/subjects/slice'
import ExercicesReducer from './reducers/exercices/slice'
import ExamsReducer from './reducers/exams/slice'
import TypeExamsReducer from './reducers/typeExams/slice'
import RemarquesReducer from './reducers/remarques/slice'
import TypeRemarquesReducer from './reducers/typeRemarques/slice'
import PaymentCategoriesReducer from './reducers/paymentCategories/slice'
import PaymentsReducer from './reducers/payments'
import ExpendituresReducer from './reducers/expenditures/slice'
import PeriodsReducer from './reducers/periods/slice'
import NotificationsReducer from './reducers/notifications/slice'
import GlobalReducer from './reducers/global/globalSlice'
import ChatbotReducer from './reducers/chatbot/slice'
import InventoryReducer from './reducers/inventory/slice'
import InventoryTypeReducer from './reducers/inventoryType/slice'
import EmailsReducer from './reducers/emails/slice'

export const store = configureStore({
  reducer: {
    auth: AuthReducer,
    licenses: LicenseReducer,
    users: UsersReducer,
    establishments: EstablishmentsReducer,
    classes: ClassesReducer,
    subjects: SubjectsReducer,
    exercices: ExercicesReducer,
    exams: ExamsReducer,
    typeExams: TypeExamsReducer,
    remarques: RemarquesReducer,
    typeRemarques: TypeRemarquesReducer,
    paymentCategories: PaymentCategoriesReducer,
    payments: PaymentsReducer,
    expenditures: ExpendituresReducer,
    periods: PeriodsReducer,
    notifications: NotificationsReducer,
    global: GlobalReducer,
    chatbot: ChatbotReducer,
    inventory: InventoryReducer,
    inventoryType: InventoryTypeReducer,
    emails: EmailsReducer,
  },
  middleware: getDefaultMiddleware({
    immutableCheck: {
      ignoredPaths: ['inventory.inventoryItems', 'users.users', 'exercices.exercices', 'exams.exams'],
      warnAfter: 64,
    },
    serializableCheck: {
      ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      ignoredPaths: ['inventory.inventoryItems', 'users.users', 'exercices.exercices', 'exams.exams'],
      warnAfter: 64,
    },
  }),
  devTools: process.env.NODE_ENV !== 'production',
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
